// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.payment.FindAnonymousPaymentInvoicesRequest */
/* istanbul ignore next */
@GandalfModel
export class FindAnonymousPaymentInvoicesRequest extends GandalfModelBase {

	@GandalfLabel('Payer')
	@GandalfValidator({ notNull: { message: 'Payer is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	payerAnonymousId!: number;

	@GandalfLabel('Payment Location')
	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

}
